<template row wrap>
  <div id="subject-view">
    <div class="select-document-type">
      <span style="align-items: center; margin-top: 20px; justify-content: center; display:block;">
        <v-layout id="layout_input" style="align-items: center; justify-content: center;">
          <h4 class="mx-3" style="margin: 20px">{{i18n('Moeda origem')}}</h4>
            <v-flex xs1>
              <div data-testid="new-transaction-from-currency-select">
                <v-select
                v-model="selected_currency.from_currency"
                :items="options_currency_from"
                filled
                color="#27DABC"
                class="font-weight-black"
                ></v-select>
              </div>
            </v-flex>
            <h4 style="margin: 20px">{{i18n('Moeda destino')}}</h4>
            <v-flex xs1>
              <div data-testid="new-transaction-destination-currency-select">
                <v-select
                  v-model="selected_currency.to_currency"
                  :items="options_currency_to"
                  filled
                  color="#27DABC"
                  class="font-weight-black"
                ></v-select>
              </div>
            </v-flex>
          </v-layout>
        </span>
    </div >
    <div class="buttons-container">
      <v-btn class="default-button" color="#BCC1D1" dark @click="$emit('handle-event', {back: true})" data-testid="new-transaction-rollback-button">
        {{i18n('Voltar')}}
      </v-btn>
      <v-btn class="default-button" color="#27DABC" :disabled="selected_currency.from_currency == '' || selected_currency.to_currency == ''" dark @click="goForward()" data-testid="new-transaction-continue-button">
        <div class="icon-confirm">
          {{i18n('Prosseguir')}}
          <ion-icon name="arrow-forward" style="padding: 10px;"></ion-icon>
        </div>
      </v-btn>
    </div>
  </div>
</template>
<script>
import { BankAccountsApi } from '@/shared/BankAccountsApi'
export default {
  name: 'CurrencySelectView',
  props: {
    subject: {
      type: Object
    },
    operation: {
      type: String
    }
  },
  data() {
    return {
      internalBankAccounts: [],
      selected_currency:{
        from_currency: '',
        to_currency: '',
      },
      options_currency_from: [],
      options_currency_to: [],
      fromDisabled: false,
      toDisabled: false
    }
  },
  watch: {
    'selected_currency.from_currency'(val, old_val){
      if (this.operation == 'receive' && this.$root.isLocalCurrency(this.selected_currency.from_currency) && this.$root.isLocalCurrency(this.selected_currency.to_currency)){
        return this.selected_currency.from_currency != this.selected_currency.to_currency ? this.selected_currency.to_currency = '' : false
      }
      if (this.operation == 'pay' && this.$root.isLocalCurrency(this.selected_currency.from_currency) && this.$root.isLocalCurrency(this.selected_currency.to_currency)){
        return this.selected_currency.from_currency != this.selected_currency.to_currency ? this.selected_currency.to_currency = '' : false
      }
      if (this.operation == 'exchange_internal' && this.selected_currency.from_currency === this.selected_currency.to_currency){
        this.selected_currency.to_currency = old_val
      }
      if (this.operation != 'fee_payoff' && this.$root.isLocalCurrency(this.selected_currency.from_currency) && this.$root.isLocalCurrency(this.selected_currency.to_currency)) {
        return this.selected_currency.to_currency = ''
      }
    },
    'selected_currency.to_currency'(val, old_val){
      if (this.operation == 'receive' && this.$root.isLocalCurrency(this.selected_currency.from_currency) && this.$root.isLocalCurrency(this.selected_currency.to_currency)){
        return this.selected_currency.from_currency != this.selected_currency.to_currency ? this.selected_currency.from_currency = '' : false
      }
      if (this.operation == 'pay' && this.$root.isLocalCurrency(this.selected_currency.from_currency) && this.$root.isLocalCurrency(this.selected_currency.to_currency)){
        return this.selected_currency.from_currency != this.selected_currency.to_currency ? this.selected_currency.from_currency = '' : false
      }
      if (this.operation == 'exchange_internal' && this.selected_currency.from_currency === this.selected_currency.to_currency){
        this.selected_currency.from_currency = old_val
      }
      if (this.operation != 'fee_payoff' && this.$root.isLocalCurrency(this.selected_currency.from_currency) && this.$root.isLocalCurrency(this.selected_currency.to_currency)) {
        return this.selected_currency.from_currency = ''
      }
    }
  },
  methods: {
    i18n(str, from, to) {
      return this.$root.l(str).replace('%s', from).replace('%s', to)
    },
    goForward() {
      this.$emit('handle-event', {
        from_currency: this.selected_currency.from_currency,
        to_currency: this.selected_currency.to_currency,
        selected_operation: this.operation
      })
    },
    initCurrency(){
      const all_currencies = this.$root.currencies.concat(this.$root.local_currencies)
      if(this.operation == 'receive') {
        this.selected_currency.from_currency = this.$root.local_currencies[0]
        this.selected_currency.to_currency = this.$root.currencies[0]

        this.options_currency_from = this.$root.local_currencies
        this.options_currency_to = all_currencies
      }
      if(this.operation == 'pay') {
        this.selected_currency.from_currency = this.$root.currencies[0]
        this.selected_currency.to_currency = this.$root.local_currencies[0]

        this.options_currency_from = all_currencies
        this.options_currency_to = this.$root.local_currencies
      }
      if(this.operation == 'deposit') {
        this.selected_currency.from_currency = this.$root.currencies[0]
        this.selected_currency.to_currency = this.internalBankAccounts[0]

        this.options_currency_from = Array.from(this.$root.currencies)
        this.options_currency_to = this.internalBankAccounts
      }
      if(this.operation == 'withdrawal_internal') {
        this.selected_currency.from_currency = this.internalBankAccounts[0]
        this.selected_currency.to_currency = this.$root.currencies[0]

        this.options_currency_from = this.internalBankAccounts
        this.options_currency_to = Array.from(this.$root.currencies)
      }
      if(this.operation == 'exchange_internal' || this.operation == 'fee_payoff') {
        this.selected_currency.from_currency = this.internalBankAccounts[0]
        this.selected_currency.to_currency = this.internalBankAccounts[1]

        this.options_currency_from = this.internalBankAccounts
        this.options_currency_to = this.internalBankAccounts
      }
    },
    loadInternalBankAccounts() {
      let successCallback = (response) => {
        if (response.body.data) {
          this.internalBankAccounts = response.body.data.filter( ( record ) => { return record.internal } ).map((a) => { return a.currency })
          this.initCurrency()
        }
      }

      let errorCallback = (response) => {
        console.log('errorCallback', response)
      }
      BankAccountsApi.onlyGet(this, this.$root.urls.bank_accounts, successCallback, errorCallback, {filter: "internal"});
    }
  },
  mounted() {
    this.loadInternalBankAccounts()
  }
}

</script>
<style>
.default-button {
  width: 160px;
  padding: 30px 15px;
  border-radius: 6px;
  font-weight: 700;
}
.icon-confirm {
  padding-left: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.v-select__selection,
.v-select__selection--comma,
.v-select.v-text-field input {
  color: #27dabc;
  margin-top: 11px;
}
.li_charge{
  font-size: 18px;
  margin-left: 50px;
  color: #BCC1D1;
}

.caption {
  font-size: 12px!important;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/NewTransaction/CurrencySelectView.vue